import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';

import { IEmployee, Project } from '../../model/top.model';
import { EmployeeData } from '../../providers/employee-data';
// import { TimeRegistrationData } from '../../providers/time-registration-data';

@Component({ selector: 'modal-employee', templateUrl: 'select-employee.html' })
export class EmployeeModal {
  navParams;
  viewCtrl;
  //selectedEmployees: Array<IEmployee>;
  selectedEmployeeIds: Array<string>;
  employees: Array<IEmployee>;
  checkedEmployees: Object = {};
  project: Project;


  constructor(
    navParams: NavParams,
    viewCtrl: ViewController,
    private employeeData: EmployeeData,
    // private timeRegistrationData: TimeRegistrationData
  ) {
    this.navParams = navParams;
    this.viewCtrl = viewCtrl;
    this.employeeData.getEmployees(false).then((result: Array<IEmployee>) => {
      this.employees = this.employeeData.employees;
      this.project = this.navParams.get('project');
      if (this.project) {
        // this.timeRegistrationData.getTimeRegistrations().then((timeRegistrations) => {
        //     this.employees.forEach((employee, index) => {
        //         this.checkedEmployees[employee.employee_id] = false;
        //         this.employees[index].hasProjectTimeRegistration = timeRegistrations.some((timeRegistration) => (timeRegistration.project_id == this.project.project_id && timeRegistration.employee_id == employee.employee_id))
        //     });
        //     //   this.selectedEmployees = this.project.employees;
        //     //   this.selectedEmployees.forEach((employee, index) => {
        //     //       this.checkedEmployees[employee.uuid] = true;
        //     //   });
        //     this.selectedEmployeeIds = this.project.employees.map(employee => {
        //         return employee.employee_id;
        //     });
        //     this.selectedEmployeeIds.forEach((employeeId, index) => {
        //         this.checkedEmployees[employeeId] = true;
        //     });
        // });
      }
    });

  }

  dismiss(action) {
    //this.selectedEmployees = [];
    this.selectedEmployeeIds = [];
    this.employees.forEach((employee) => {
      if (this.checkedEmployees[employee.employee_id]) {
        //this.selectedEmployees.push(employee);
        this.selectedEmployeeIds.push(employee.employee_id);
      }
    });
    // this.viewCtrl.dismiss(this.selectedEmployees);
    this.viewCtrl.dismiss(this.selectedEmployeeIds);
  }
  cancel() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/modals/select-employee/select-employee.ts